import { render } from "./BreadcrumpsCustom.vue?vue&type=template&id=0b0b0256&scoped=true"
import script from "./BreadcrumpsCustom.vue?vue&type=script&lang=js"
export * from "./BreadcrumpsCustom.vue?vue&type=script&lang=js"

import "./BreadcrumpsCustom.vue?vue&type=style&index=0&id=0b0b0256&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0b0256"]])

export default __exports__